// ####AUTH####
export const LOGIN = "/auth-engine/login";
export const CONFIG = "/config";
export const GET_PERMISSIONS = "/permissions";

export const USER_DETAILS = "/auth-engine/user/me";
export const GENERATE_EVENT_STATS =
  "/generate-event-stats/0b4b8f75934904e47783dbfc5c6d9b319280355f740a92f533cc799dd713bc75";
export const IMAGE_UPLOAD = `${process.env.REACT_APP_API_REPORT_HOST}/media`;
// ####TEMPLATE####
export const TEMPLATE = "/templates";
export const COMPANY_ADMIN_TEMPLATE ="/companies/{{company_uuid}}/template/{{template_uuid}}"
export const TEMPLATE_PAUSE_STATUS ="templates/{{uuid}}/status"
export const LIST_COMPANY_TEMPLATE = "/company-templates";
export const UPDATE_COMPANY_TEMPLATE_ORDER=`/companies/{{uuid}}/sort-template-order`
export const SYNC_COMPANY_TEMPLATE = '/resync-event-stats'
// ####REPORT####
//TIME
export const TIME_SUMMARY_REPORT = "/time-summary-reports";
export const TIME_GRAPH_REPORT = "/time-graph-reports";

//DATE
export const DAY_SUMMARY_REPORT = "/day-summary-reports";
export const DAY_GRAPH_REPORT = "/day-graph-reports";

//OPERAOTR
export const OPERATOR_DETAIL_REPORT =
  "/operators/{{uuid}}/operator-detail-reports";
export const OPERATOR_SUMMARY_REPORT = "/operator-summary-reports";

//PART
export const PART_DETAIL_REPORT = "/parts/{{uuid}}/part-detail-reports";
export const PART_SUMMARY_REPORT = "/part-summary-reports";

//PERFORMANCE
export const PERFORMANCE_REPORT = "templates/{{uuid}}/performance-report";
export const PNL_REPORT = "/pnl-reports"
/////#####ENTITY#####
export const FETCH_ENTITY_HIERARCY =
  "/config-engine/entity/{NODE_TYPE}/{NODE_ID}";
export const DEVICE = "/config-engine/device";
export const DEVICE_BY_IDS = "/config-engine/device/get/byDeviceIds";

/////########LOCATION#########part-summary-reports
export const SCOPE_ZONE_PARENT_HIERARCHY =
  "/location-engine/zone/assignedParents/{NODE_TYPE}/{NODE_ID}";

// ####TEMPLATE####
export const COMPANY = "/companies";
export const EMAIL_TIME_SUMMARY = "/email-time-summary"
export const COMPANY_STAFFS = "/companies/{{uuid}}/staffs";
export const COMPANY_STAFFS_ATTENDENCE = "/companies/{{uuid}}/staffs/attendance";

export const IMPORT_STAFFS = "/companies/{{uuid}}/import-staffs"
export const IMPORT_STAFFS_ATTENDENCE = "/companies/{{uuid}}/import-attendance"


export const UPDATE_COMPANY_STAFFS = "/companies/{{uuid}}/staffs/{{staff_id}}";

export const COMPANY_PARTS = "/companies/{{uuid}}/parts";
export const COMPANY_TEMPLATE_SHIFT_CONFIG = "/template-shift-config";
export const DELETE_TEMPLATE_SHIFT_CONFIG = "/template-shift-config/{{config_id}}"

// ####PARTS####
export const CREATE_PART = "/companies/{{company_uuid}}/parts";
export const UPDATE_DELETE_PART = "/companies/{{company_uuid}}/parts/{{uuid}}";
// ###JOBCARD####
export const PDF_JOB_CARD = "/companies/{{company_uuid}}/shift-job-cards"
// ####REPORT PDF####
export const PDF_TIME_SUMMARY_REPORT = "/pdf-time-summary-reports";
export const PDF_DAY_SUMMARY_REPORT = "/pdf-day-summary-reports";
export const PDF_OPERATOR_DETAIL_REPORT =
  "/operators/{{uuid}}/pdf-operator-detail-reports";
export const PDF_OPERATOR_SUMMARY_REPORT = "/pdf-operator-summary-reports";
export const PDF_PART_DETAIL_REPORT = "/parts/{{uuid}}/pdf-part-detail-reports";
export const PDF_PART_SUMMARY_REPORT = "/pdf-part-summary-reports";
export const PDF_PERFORMANCE_REPORT =
  "templates/{{uuid}}/pdf-performance-report";

// ###REPORT EXCEL###
export const EXCEL_MULTIDAY_DETAIL_REPORT = `/multiday-detail-reports`;
export const EXCEL_TIME_SUMMARY_REPORT = `/time-summary-reports/excel`
export const EXCEL_PNL_SUMMARY_REPORT = `/pnl-summary-reports/excel`



// DASHBOARD
export const DASHBOARD_TEMPLATES ='/dashboard-templates'
export const DASHBOARD_STATS ="/dashboard-stats"

// BREAKDOWN
export const BREAK_DOWN_SETTING = "templates/{{uuid}}/breakdown-slots";
export const BREAK_DOWN_POST = "templates/{{uuid}}/breakdown";
export const BREAK_DOWN_REASONS = 'config?query=breakdown_reasons'
export const BREAK_DOWN_GRAPH = 'templates/{{templateId}}/breakdown-graph'

// PRODUCTION COMPONENT

export const PRODUCTION_COMPONENT ='company/{{uuid}}/production-components'
export const PRODUCTION_COMPONENT_UP_DEL ='company/{{uuid}}/production-components/{{productionid}}'

// NOTIFICATION SETTINGS

export const NOTIFICATION_SETTINGS = 'companies/{{uuid}}/notification-settings'
